import { clearCreativeDrawerResources } from '../actions';

const cleanCreativesEditingResources = () => dispatch => {
    dispatch(clearCreativeDrawerResources());
};

export default cleanCreativesEditingResources;
